export const experience = [
  {
    text: "2023",
    subTitle: "Namangan",
    title: "Mentor at Algoritm Education Center",
    desc: "Teching students, Building projects",
  },
  {
    text: "2022",
    subTitle: "Toshkent",
    title: "Internal Shift in WebBrain",

    desc: "Houzin project dealing with the sale of a houses,",
  },
];

export const education = [
  {
    text: "2022",
    subTitle: "Namangan",
    title: "Algoritm IT",
    desc: "Web developement, Basckend developement, Databases",
  },
  {
    text: "2022",
    subTitle: "Toshkent",
    title: "WebBrain IT Academy",
    desc: "Web developement,",
  },
  {
    text: "2014",
    subTitle: "Moscow",
    title: "English school ITEC",
  },
];
